import {
  GET_COUPONS,
  GET_REFUND_COUPONS,
  SELECT_COUPON,
  CANCEL_COUPON,
  INIT_COUPON,
} from './actions';

const initialState = {
  couponsData: [],
  selectCouponCodes: [], // 已选的变更优惠券code
  couponsPsgSegment: {}, // 已选的变更优惠券对应使用的乘机人和航段
  couponsMap: {}, // 已选的变更优惠券数据
};

export default function CouponsReducer(state = initialState, action) {
  switch (action.type) {
    case `${GET_REFUND_COUPONS}_SUCCESS`:
    case `${GET_COUPONS}_SUCCESS`:
      const {
        payload: {
          data: {
            result: { coupon },
          },
        },
      } = action;
      if (coupon && coupon.length !== 0) {
        let prevUrl = window.sessionStorage.getItem('historyUrl');
        if (prevUrl.includes('TicketChange') && state.selectCouponCodes.length > 0) {
          return Object.assign({}, state, {
            couponsData: coupon,
            selectCouponCodes: [],
            couponsPsgSegment: {},
            couponsMap: {},
          });
        } else {
          return Object.assign({}, state, {
            couponsData: coupon,
          });
        }
      } else {
        return {
          couponsData: [],
          selectCouponCodes: [],
          couponsPsgSegment: {},
          couponsMap: {},
        };;
      }
    case SELECT_COUPON:
      delete action.couponData.originData;
      return Object.assign({}, state, {
        selectCouponCodes: [...state.selectCouponCodes, action.code],
        couponsMap: Object.assign({}, state.couponsMap, {
          [action.code]: Object.assign(
            {},
            state.couponsData.filter(
              item => item.discountcode === action.code
            )[0],
            {
              couponData: action.couponData,
            }
          ),
        }),
        couponsPsgSegment: Object.assign({}, state.couponsPsgSegment, {
          [action.code]: action.psgSegmentData,
        }),
      });
    case CANCEL_COUPON:
      let obj = { ...state.couponsMap },
        arr = [...state.selectCouponCodes],
        psg = { ...state.couponsPsgSegment };
      delete obj[action.couponCode];
      delete psg[action.couponCode];
      arr.splice(arr.indexOf(action.couponCode), 1);
      return Object.assign({}, state, {
        selectCouponCodes: arr,
        couponsMap: obj,
        couponsPsgSegment: psg,
      });
    case INIT_COUPON:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/coupon/modules/coupon.js